var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.colWrapper,_vm._b({tag:"component"},'component',_vm.colProps,false),[_c('b-form-group',{staticClass:"text-capitalize",attrs:{"label":_vm.label,"label-for":_vm.id}},[_c('flat-pickr',{staticClass:"form-control",attrs:{"value":_vm.value,"id":"delayed_record_minutes","config":{
        enableTime: _vm.enableTime,
        dateFormat: _vm.dateFormat,
        time_24hr: true,
        minuteIncrement: _vm.minuteIncrement,
        mode: _vm.mode,
        allowInput: false,
        onReady: _vm.rememberRangeDays,
        onChange: _vm.applyRangeDefaults,
      }},on:{"input":function (value) { return _vm.$emit('input', value); }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }